import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/Vertical_logo.svg'


const _hoisted_1 = { class: "left-block-wrapper d-flex flex-column justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_3 = { class: "auth-wrapper container" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "title-wrapper d-flex"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Create your smace account", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "auth-form-wrapper" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "signin"
}
const _hoisted_11 = { class: "account-type d-flex justify-content-center" }
const _hoisted_12 = { class: "account-type d-flex justify-content-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Don't have an account?", -1)

import { ref, onMounted } from "vue";
import { computed } from "vue";
import { clearAllCookies, useStore } from "@/store";
import PasswordlessLogin from "@/views/auth/PasswordlessLogin.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftSideBlock',
  setup(__props) {

const store = useStore();
const getUserSession = computed(() => store.getters.getUserSession);
const isSignUp = ref(false);
const isPasswordlessLogin = ref(false);
onMounted(() => { store.dispatch('logout') });

return (_ctx: any,_cache: any) => {
  const _component_authenticator = _resolveComponent("authenticator")!
  const _component_authenticator_sign_up_form_fields = _resolveComponent("authenticator-sign-up-form-fields")!
  const _component_amplify_check_box = _resolveComponent("amplify-check-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!getUserSession.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (isSignUp.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (isSignUp.value)
                ? (_openBlock(), _createBlock(_component_authenticator, {
                    key: 0,
                    "initial-state": "signUp",
                    "login-mechanisms": ['email']
                  }))
                : _createCommentVNode("", true),
              (!isSignUp.value && !isPasswordlessLogin.value)
                ? (_openBlock(), _createBlock(_component_authenticator, {
                    key: 1,
                    "login-mechanisms": ['email'],
                    "initial-state": "signIn",
                    "hide-sign-up": true
                  }, {
                    "sign-up-fields": _withCtx(() => [
                      _createVNode(_component_authenticator_sign_up_form_fields),
                      _createVNode(_component_amplify_check_box)
                    ]),
                    default: _withCtx(({ user, signOut }) => [
                      _createElementVNode("h1", null, "Hello " + _toDisplayString(user.username) + "!", 1),
                      _createElementVNode("button", { onClick: signOut }, "Sign Out", 8, _hoisted_9)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (isPasswordlessLogin.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(PasswordlessLogin)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (isPasswordlessLogin.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "account-type-mode",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isPasswordlessLogin.value = !isPasswordlessLogin.value))
                    }, " Sign in with Password "))
                  : _createCommentVNode("", true),
                (!isPasswordlessLogin.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "account-type-mode",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isPasswordlessLogin.value = !isPasswordlessLogin.value))
                    }, " Sign in via Passwordless Login "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode("  "),
                _createElementVNode("span", {
                  class: "account-type-mode",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isSignUp.value = !isSignUp.value))
                }, _toDisplayString(isSignUp.value ? "Sign in" : "Sign up"), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})